import { useContext } from "react";
import LocaleContext from "../locale/LocaleContext";
export var useLocale = function () { return useContext(LocaleContext); };
